module.exports = __webpack_public_path__ + "h5/img/offer_2024.cfb45276.png";